import React from 'react';
import Img from '../Img';

const UTRModal = (props) => {
    const { scrollable, title, actionLabel, onActionClick, onCloseClick, className, disableActionButton, config = {}, 'data-testid': dataTestId } = props;
    const { noModalBodyPadding, modalBodyPaddingClassName, modalFooterPaddingClassName } = config;

    const onOverlayClick = () => {
        onCloseClick();
    };

    const onModalClick = (e) => {
        e.stopPropagation();
    };

    return (
        <div className={`utr-modal-overlay`} onClick={onOverlayClick} data-testid={dataTestId}>
            <div className={`utr-modal ${scrollable ? 'utr-modal-scrollable' : ''} ${className}`} style={props.style} onClick={onModalClick}>
                <div className={`utr-modal-header`}>
                    <div className="container">
                        <div className="col d-flex d-md-none justify-space-between align-items-center">
                            <div className="close-area" onClick={onCloseClick} data-testid={dataTestId && `${dataTestId}.mobile-close-btn`}>
                                <Img className="close-icon" src="/img/icons/close-icon-lg.svg" />
                            </div>
                            <div className="title-span text-medium text-uppercase text-dark text-center" data-testid={dataTestId && `${dataTestId}.title`}>{title}</div>
                            {onActionClick && <div className="link underline" onClick={onActionClick} data-testid={dataTestId && `${dataTestId}.mobile-action-link`}>{actionLabel}</div>}
                            {!onActionClick && <div className="text-gray" data-testid={dataTestId && `${dataTestId}.mobile-action-label`}>{actionLabel}</div>}
                        </div>
                        <div className="col d-none d-md-flex jce align-items-center">
                            <div className="close-area" onClick={onCloseClick} data-testid={dataTestId && `${dataTestId}.desktop-close-btn`}>
                                <Img className="close-icon" src="/img/icons/close-icon-lg.svg" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`utr-modal-body ${modalBodyPaddingClassName || (noModalBodyPadding ? 'pr0 pl0' : '')}`}>
                    {props.children}
                </div>
                {!!actionLabel && (
                    <div className={`utr-modal-footer p16 d-none d-md-block ${modalFooterPaddingClassName || ''}`}>
                        <button
                            type="button"
                            className={`btn btn-primary btn-large btn-block`}
                            onClick={onActionClick}
                            disabled={!onActionClick || disableActionButton}
                            data-testid={dataTestId && `${dataTestId}.action-btn`}
                        >
                            {actionLabel}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default UTRModal;
